var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoto = function SvgPhoto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 5.25C23 4.03125 22.0117 3 20.8438 3H16.8906L16.3066 1.5C15.9922 0.609375 15.1836 0 14.2852 0H8.66992C7.77148 0 6.96289 0.609375 6.64844 1.5L6.10938 3H2.15625C0.943359 3 0 4.03125 0 5.25V18.75C0 20.0156 0.943359 21 2.15625 21H20.8438C22.0117 21 23 20.0156 23 18.75V5.25ZM16.8906 12C16.8906 15.1406 14.4648 17.625 11.5 17.625C8.49023 17.625 6.10938 15.1406 6.10938 12C6.10938 8.90625 8.49023 6.375 11.5 6.375C14.4648 6.375 16.8906 8.90625 16.8906 12ZM15.4531 12C15.4531 9.75 13.6562 7.875 11.5 7.875C9.29883 7.875 7.54688 9.75 7.54688 12C7.54688 14.2969 9.29883 16.125 11.5 16.125C13.6562 16.125 15.4531 14.2969 15.4531 12Z",
    fill: "#C4C4C4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo.d3bbeefa.svg";
export { ForwardRef as ReactComponent };